import { render, staticRenderFns } from "./CostModifyCommands.vue?vue&type=template&id=dc4974ba&"
import script from "./CostModifyCommands.vue?vue&type=script&lang=ts&"
export * from "./CostModifyCommands.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports